import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { i18n, localeReady } from './i18n'
import './styles/base.css'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(i18n)

// localeReady 완료 전에 mount하면 ko 외 언어가 fallbackLocale(ko)로 잠깐
// 렌더링됐다가 뒤늦게 바뀌는 깜빡임이 생긴다 — kei.bio의 동일 패턴 재사용.
void localeReady.then(() => app.mount('#app'))

// 2026-10-04 새 버전 자동 반영 — 사용자가 이전 버전(CC 버튼 없는 화면)을 계속 보고 있던 문제.
// 새 서비스워커가 페이지를 넘겨받으면(controllerchange) 회의 밖일 때만 새로고침한다. 회의 중이면 미뤘다가 회의에서 나온 뒤 반영.
// 처음 방문(이전 서비스워커 없음)에는 새로고침하지 않는다.
if ('serviceWorker' in navigator) {
  const hadController = !!navigator.serviceWorker.controller
  let pendingReload = false
  let reloading = false
  const inRoom = () => !!(window as unknown as { __keiInRoom?: boolean }).__keiInRoom
  const reload = () => {
    if (reloading) return
    reloading = true
    location.reload()
  }
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!hadController) return
    if (inRoom()) pendingReload = true
    else reload()
  })
  router.afterEach(() => {
    if (pendingReload) setTimeout(() => !inRoom() && reload(), 300)
  })
  // 탭으로 돌아올 때마다 새 버전 확인(회의 중이면 확인만, 적용은 회의 뒤)
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) navigator.serviceWorker.getRegistration().then((r) => r?.update()).catch(() => {})
  })
}
